// these variables used for wordings on the warning modal dailog
export const VIEW_SUBSCRIPTION_ON_NEXT_SCREEN = 'You can view those subscriptions on the next screen.';
export const CONFIRM_OK_LABEL = 'Ok, got it';
export const LINKED_SUBSCRIPTION_DESCRIPTION = (type: string) =>
  `Doing this will also change the ${type} for other product and app subscriptions on this site that belong to the same product family.`;

export const CANCELLED_LINKED_ENT_HEADER = 'Some associated subscriptions could also be canceled';
export const CANCELLED_LINKED_ENT_DESCRIPTION =
  'These subscriptions will be listed on the next screen, before you confirm the cancellation.';

const OTHER_SUBSCRIPTION_CHANGED = (type: string) => `${type} will also change for other subscriptions`;

export const COBILL_WARNING_HEADER = OTHER_SUBSCRIPTION_CHANGED('Billing date');
export const TRANSFER_TXA_WARNING_HEADER = OTHER_SUBSCRIPTION_CHANGED('Billing account');
export const SWITCH_BILING_PROFILE_WARNING_HEADER = OTHER_SUBSCRIPTION_CHANGED('Billing profile');
export const UNDO_SCHEDULED_CHANGES_HEADER = 'Other subscriptions will also be affected';
export const UNDO_SCHEDULED_CHANGES_DESCRIPTION =
  'This action will reverse the same scheduled changes for all the subscriptions listed on the next screen.';
